export const isPostPurchaseLanding = (): boolean => {
    return new URL(window.location.href).searchParams.has("package");
};
